import axios from './index';

export const getReportsRequest = (values) =>
  axios.get(`/v1/vendors/reports/get/summary/${values?.from || '-'}/${values?.to || '-'}`);
